<template>
  <transition name="fade">
    <div class="confirm-dialog-container" v-if="confirmDialogShow">
      <div class="confirm-dialog-wrapper">
        <div class="title-icon">
          <img :src="activitySetting.dialogTitleIcon || '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/dialog-title-icon.png'" alt="">
        </div>
        <div class="guess-price" v-if="guessPrice">{{ guessPrice }}元</div>
        <p class="tips" v-if="guessPrice">我的猜价</p>
        <div class="result-msg" v-if="resultMsg">{{ resultMsg }}</div>
        <div class="btn-wrapper">
          <div class="left" @click.stop="leftClick" v-if="leftBtnText">{{ leftBtnText }}</div>
          <div class="right" @click.stop="rightClick" v-if="rightBtnText">{{ rightBtnText }}</div>
        </div>
        <div class="close-icon-wrapper" @click.stop="closeDialog">
          <div class="close-icon"></div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  props: {
    confirmDialogShow: {
      type: Boolean,
      default: false
    },
    activitySetting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    guessPrice: {
      type: Number,
      default: Number
    },
    resultMsg: {
      type: String,
      defautl: ''
    },
    leftBtnText: {
      type: String,
      default: '我知道了'
    },
    rightBtnText: {
      type: String,
      default: '分享好友'
    }
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    leftClick() {
      this.$emit('on-left-click')
    },
    rightClick() {
      this.$emit('on-right-click')
    },
    closeDialog() {
      this.$emit('on-close')
    }
  }
}
</script>
<style lang="scss">
@import '../assets/style/index.scss';
.confirm-dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.7);
  transform: translateZ(1px);
  .confirm-dialog-wrapper {
    background: #fff;
    width: pr(560);
    min-height: pr(500);
    border-radius: pr(24);
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%);
    z-index: 1002;
    .title-icon {
      width: pr2(150);
      height: pr2(142);
      margin: pr2(-50) auto 0 auto;
      >img {
        width: 100%;
        height: 100%;
      }
    }
    .guess-price {
      font-family: PingFangSC-Medium;
      font-size: pr(34);
      color: #FF6600;
      text-align: center;
      line-height: 1;
      font-weight: bolder;
      margin-bottom: pr(10);
    }
    .tips {
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: pr(22);
      color: #828DA0;
      text-align: center;
      line-height: 1;
      margin-bottom: pr(30);
    }
    .result-msg {
      font-family: PingFangSC-Regular;
      font-size: pr(24);
      color: #5F687E;
      text-align: center;
      max-width: pr(430);
      margin: 0 auto;
    }
    .btn-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      position: absolute;
      bottom: pr(40);
      left: 0;
      z-index: 1002;
      padding: 0 pr(40);
      box-sizing: border-box;
      >div {
        height: pr(80);
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular;
        font-size: pr(28);
        text-align: center;
        line-height: 1;
        border-radius: pr(8);
      }
      .left {
        flex: 1;
        border: pr(2) solid rgba(62,82,230,0.50);
        color: #3E52E6;
      }
      .right {
        flex: 1;
        color: #fff;
        background: #3E52E6;
        margin-left: pr(20);
      }
    }
    .close-icon-wrapper {
      width: pr2(40);
      height: pr2(40);
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: pr2(12);
      .close-icon {
        width: pr2(12);
        height: pr2(12);
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABhklEQVRYR9WYzU4CQQyAp6sPY+AICXLyBfAmB30LE30KTXgLPMhNXoCTksBRwsPo1Awwy+6yO9t2x03hRtKfb9pO21kwyn6gjMekQIh4sVxvHtHADRhcDHqdCQD8/gdwyFcK9LX6frJoXjxAAsn7oHf1AAA/MaEQ8XK53k4t2vHRl3m+7ndf3f8U6HO1+UDEUdZ5bKgymB0EwHzY79zmgIoRih2pKhjnJ4GSCO3zun3LhjIWVBhmVxr3vl5zt4ygyK4prs2Ta881ECp4ia3SPiQxVAST2qhsjFKDDqyJbrBTSwxLdLLRrR0dHAcc2araqwWipsDJFTuwpG2QgAhQMydj0d4VT87t9mSgOqiyFHBhcqODOkBDdRJjDrIi5B0eoNyYOUnRfjYls8M4YG8K5w+kKmVUGMl19zrklNU0vXavPaUDt9YYKTB+7+bIikaHxIFEhzRcmxhuoqt/QWtyuhhbo94lX90zSN1DUf1TWrJcUXYq8scGdZ9jKKdrQ4Y87duAcT7+ACQTgEMFO5JYAAAAAElFTkSuQmCC') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .1s ease-in-out;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .fadeIn-enter-active {
    transition: opacity .1s ease-in-out;
  }
}
</style>
